<span class="h2">{{ this.formatarTexto() }}</span>
